<template>
  <NavigationBar
    class="ai-chat-header select-none position-initial! [&_.left]:w-auto! [&_.center]:justify-start! h-auto! pb-6"
  >
    <template v-slot:backIcon>
      <img
        src="@/assets/images/ai-chat/back.png"
        class="w-10 h-18 ml-3"
        alt="back"
      />
    </template>
    <template v-slot:title>
      <div class="ml-12 flex items-center">
        <img
          src="@/assets/images/ai-chat/logo.png"
          class="size-36 mr-10"
          alt="logo"
        />
        <div>
          <div class="text-17 leading-20 font-600">
            {{ t("message.ai.title") }}
          </div>
          <div class="text-12 text-#999 font-400 leading-14">
            {{ t("message.ai.slogan") }}
          </div>
        </div>
      </div>
    </template>
    <template v-slot:right>
      <div class="flex items-center">
        <NavCart />
        <img
          src="@/assets/images/ai-chat/brush.png"
          class="size-32 ml-4 mr-15"
          alt="brush"
          @click="emit('clearHistoryMessage')"
        />
      </div>
    </template>
  </NavigationBar>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import NavCart from "./Cart.vue";

const { t } = useI18n();

const emit = defineEmits<{
  (e: "clearHistoryMessage"): void;
}>();
</script>
